<template>
  <div class="people-details-container">
    <div class="people-details-body">
      <div class="content">
        <div class="form">
          <el-form
            class="people-details-input"
            label-position="right"
            label-width="120px"
            :inline="true"
            ref="peopleDetails"
            :model="formData"
            :rules="formRules"
            @submit.native.prevent
          >
<!--            基本信息字段-->
            <div class="item">
              <fieldset class="fieldset">
                <legend class="legend">基本信息</legend>
                <div class="details-info fixation-info">
                  <div class="left">
                    <el-form-item prop="name" v-if="normalGroup[0].isShow">
                      <span class="custom-label" slot="label" title="姓名">姓名</span>
                      <el-input v-model="formData.name" clearable></el-input>
                    </el-form-item>
                    <el-form-item prop="username" v-if="normalGroup[1].isShow">
                      <span class="custom-label" slot="label" title="用户账号">用户账号</span>
                      <el-input v-model="formData.username" clearable></el-input>
                    </el-form-item>
                    <el-form-item prop="email" v-if="normalGroup[2].isShow" :rules="normalGroup[2].isFill ? [{required: true, message: `请输入${normalGroup[2].name}`, trigger: 'blur'}] : []">
                      <span class="custom-label" slot="label" title="邮箱">邮箱</span>
                      <el-input v-model="formData.email" clearable></el-input>
                    </el-form-item>
                    <el-form-item class="phone" prop="phone" v-if="normalGroup[3].isShow" :rules="normalGroup[3].isFill ? [{required: true, message: `请输入${normalGroup[3].name}`, trigger: 'blur'}] : []">
                      <span class="custom-label" slot="label" title="手机号">手机号</span>
                      <el-input v-model="formData.phone" clearable></el-input>
                    </el-form-item>
                    <el-form-item prop="departmentId" v-if="normalGroup[4].isShow" :rules="normalGroup[4].isFill ? [{required: true, message: `请输入${normalGroup[4].name}`, trigger: 'blur'}] : []">
                      <span class="custom-label" slot="label" title="部门名称">部门名称</span>
                      <el-select
                        v-model="formData.departmentId"
                        filterable
                        @change="getPostList($event)"
                      >
                        <el-option
                          v-for="item in selectList.departmentList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item prop="postId" v-if="normalGroup[5].isShow" :rules="normalGroup[5].isFill ? [{required: true, message: `请输入${normalGroup[5].name}`, trigger: 'blur'}] : []">
                      <span class="custom-label" slot="label" title="岗位名称">岗位名称</span>
                      <el-select
                        v-model="formData.postId"
                        :disabled="formData.departmentId === ''"
                        filterable
                      >
                        <el-option
                          v-for="item in selectList.postList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item prop="superiorName" v-if="normalGroup[6].isShow" :rules="normalGroup[6].isFill ? [{required: true, message: `请输入${normalGroup[6].name}`, trigger: 'blur'}] : []">
                      <span class="custom-label" slot="label" title="直属上级">直属上级</span>
                      <u class="selected" @click="memberDialog.dialogVisible=true">{{formData.superiorName || "请选择"}}</u>
                    </el-form-item>
                    <el-form-item prop="jobNum" v-if="normalGroup[7].isShow" :rules="normalGroup[7].isFill ? [{required: true, message: `请输入${normalGroup[7].name}`, trigger: 'blur'}] : []">
                      <span class="custom-label" slot="label" title="工号">工号</span>
                      <el-input v-model="formData.jobNum" clearable disabled></el-input>
                    </el-form-item>
                    <el-form-item prop="state" v-if="normalGroup[8].isShow" :rules="normalGroup[8].isFill ? [{required: true, message: `请输入${normalGroup[8].name}`, trigger: 'blur'}] : []">
                      <span class="custom-label" slot="label" title="用户状态">用户状态</span>
                      <el-select v-model="formData.state">
                        <el-option label="有效" value="1"></el-option>
                        <el-option label="无效" value="0"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item prop="jobStatus" v-if="normalGroup[9].isShow" :rules="normalGroup[9].isFill ? [{required: true, message: `请输入${normalGroup[9].name}`, trigger: 'blur'}] : []">
                      <span class="custom-label" slot="label" title="在职状态">在职状态</span>
                      <el-select v-model="formData.jobStatus">
                        <el-option label="在职" value="1"></el-option>
                        <el-option label="离职" value="0"></el-option>
                      </el-select>
                    </el-form-item>
                    <div class="attendance">
                      <el-form-item prop="isAttendance" label="是否考勤" v-if="normalGroup[10].isShow" :rules="normalGroup[10].isFill ? [{required: true, message: `请输入${normalGroup[10].name}`, trigger: 'blur'}] : []">
                        <el-select v-model="formData.isAttendance">
                          <el-option label="是" value="是"></el-option>
                          <el-option label="否" value="否"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item prop="attendanceTypeAddr" class="address-site" label="考勤地址设置" v-if="normalGroup[11].isShow" :rules="normalGroup[11].isFill ? [{required: true, message: `请输入${normalGroup[11].name}`, trigger: 'blur'}] : []">
                        <el-select v-model="formData.attendanceTypeAddr" filterable clearable multiple collapse-tags>
                          <el-option
                            v-for="item in selectList.addressList"
                            :key="item.id"
                            :label="item.title||item.address"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item prop="attendanceType" class="attendance" label="考勤方式" v-if="normalGroup[12].isShow" :rules="normalGroup[12].isFill ? [{required: true, message: `请输入${normalGroup[12].name}`, trigger: 'blur'}] : []">
                        <el-select v-model="formData.attendanceType">
                          <el-option label="固定考勤" value="固定考勤"></el-option>
                          <el-option label="弹性考勤" value="弹性考勤"></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                    <div class="timer">
                      <el-form-item label="上班时间" prop="onDutyTimeStart" ref="onDutyTime" :error="errorMessage.onDutyTime"  v-if="normalGroup[13].isShow" :rules="normalGroup[13].isFill ? [{required: true, message: `请输入${normalGroup[13].name}`, trigger: 'blur'}] : []">
                        <el-time-select @change="onDutyTimeStartChange"
                          v-model="formData.onDutyTimeStart"
                          :picker-options="{
                        start: '00:00',
                        step: '00:01',
                        end: '24:00'
                      }"
                          placeholder="选择时间"
                        ></el-time-select>
                        <span v-if="formData.attendanceType === '弹性考勤'">——</span>
                        <el-time-select @change="onDutyTimeEndChange"
                          v-if="formData.attendanceType === '弹性考勤'"
                          v-model="formData.onDutyTimeEnd"
                          :picker-options="{
                        start: formData.onDutyTimeStart || '00:00',
                        step: '00:01',
                        end: '24:00'
                      }"
                          placeholder="选择时间"
                        ></el-time-select>
                      </el-form-item>
                      <el-form-item label="下班时间" prop="offDutyTimeStart" ref="offDutyTime" :error="errorMessage.offDutyTime"  v-if="normalGroup[14].isShow" :rules="normalGroup[14].isFill ? [{required: true, message: `请输入${normalGroup[14].name}`, trigger: 'blur'}] : []">
                        <el-time-select @change="offDutyTimeStartChange"
                          v-model="formData.offDutyTimeStart"
                          :picker-options="{
                        start: '00:00',
                        step: '00:01',
                        end: '24:00'
                      }"
                          placeholder="选择时间"
                        ></el-time-select>
                        <span v-if="formData.attendanceType === '弹性考勤'">——</span>
                        <el-time-select @change="offDutyTimeEndChange"
                          v-if="formData.attendanceType === '弹性考勤'"
                          v-model="formData.offDutyTimeEnd"
                          :picker-options="{
                        start: formData.offDutyTimeStart || '00:00',
                        step: '00:01',
                        end: '24:00'
                      }"
                          placeholder="选择时间"
                        ></el-time-select>
                      </el-form-item>
                    </div>
                    <!-- 备注 -->
                    <div class="remark">
                      <el-form-item prop="remark" v-if="normalGroup[15].isShow" :rules="normalGroup[15].isFill ? [{required: true, message: `请输入${normalGroup[15].name}`, trigger: 'blur'}] : []">
                        <span class="custom-label" slot="label" title="备注">备注</span>
                        <el-input type="textarea" :rows="2" v-model="formData.remark"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="right" v-if="normalGroup[16].isShow">
                    <el-form-item prop="imageUrl" :rules="normalGroup[16].isFill ? [{required: true, message: `请上传${normalGroup[16].name}`, trigger: 'change'}] : []">
                      <el-upload
                        class="avatar-uploader"
                        action=""
                        :show-file-list="false"
                        :http-request="uploadFile"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload"
                        name="image"
                      >
                        <img v-if="imageUrl" class="avatar" :src="imageUrl ? getDownLoadUrl(imageUrl) : imageUrl">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>
                  </div>
                </div>
              </fieldset>
            </div>
            <!-- 渲染字段 -->
            <template v-if="groups.length > 0">
              <div class="item" v-for="item in groups" :key="item.id">
                <fieldset class="fieldset">
                  <legend class="legend">{{ item.name }}</legend>
                  <div class="details-info">
                    <template v-for="column in item.columns">
                      <template v-if="column.type === '选项'">
                        <el-form-item
                          v-if="column.isShow"
                          :prop="(column.id).toString()"
                          :key="column.id"
                          :rules="column.isFill ? [{required: true, message: `请选择${column.name}`, trigger: 'change'}] : []"
                        >
                          <span
                            class="custom-label"
                            slot="label"
                            :title="column.name"
                          >{{ column.name }}</span>
                          <el-select
                            v-model="formData[column.id]"
                            :placeholder="column.placeholder"
                            filterable
                          >
                            <el-option
                              v-for="(item, index) in column.content"
                              :key="index"
                              :label="item"
                              :value="item"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </template>
                      <template v-if="column.type === '日期'">
                        <el-form-item
                          v-if="column.isShow"
                          :prop="(column.id).toString()"
                          :key="column.id"
                          :rules="column.isFill ? [{required: true, message: `请选择${column.name}`, trigger: 'change'}] : []"
                        >
                          <span
                            class="custom-label"
                            slot="label"
                            :title="column.name"
                          >{{ column.name }}</span>
                          <el-date-picker
                            v-model="formData[column.id]"
                            type="date"
                            :placeholder="column.placeholder"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                          ></el-date-picker>
                        </el-form-item>
                      </template>
                      <template v-if="column.type === '文本'">
                        <el-form-item
                          v-if="column.isShow"
                          :prop="(column.id).toString()"
                          :key="column.id"
                          :rules="column.isFill ? [{required: true, message: `请输入${column.name}`, trigger: 'blur'}, { pattern: /^(?=.*\S).+$/, message: `请输入${column.name}`, trigger: 'blur' }] : []"
                        >
                          <span
                            class="custom-label"
                            slot="label"
                            :title="column.name"
                          >{{ column.name }}</span>
                          <el-input
                            v-model="formData[column.id]"
                            :placeholder="column.placeholder"
                            clearable
                          ></el-input>
                        </el-form-item>
                      </template>
                      <template v-if="column.type === '数字'">
                        <el-form-item
                          v-if="column.isShow"
                          :prop="(column.id).toString()"
                          :key="column.id"
                          :rules="column.isFill ? [{required: true, message: `请输入${column.name}`, trigger: 'blur'}] : []"
                        >
                          <span
                            class="custom-label"
                            slot="label"
                            :title="column.name"
                          >{{ column.name }}</span>
                          <el-input
                            class="number-control"
                            v-model="formData[column.id]"
                            :placeholder="column.placeholder"
                            clearable
                            type="number"
                            @mousewheel.native.prevent="() => false"
                          ></el-input>
                        </el-form-item>
                      </template>
                    </template>
                  </div>
                </fieldset>
              </div>
            </template>
          </el-form>
        </div>
        <div class="operation">
          <el-button type="default" @click="closePage">关闭</el-button>
          <el-button type="primary" @click="saveData">保存</el-button>
        </div>
      </div>
    </div>
    <select-people-tree :memberDialog="memberDialog"  :value="formData.superior" @saveSuper="saveSuper"></select-people-tree>
  </div>
</template>

<script>
import SelectPeopleTree from './select-people-tree.vue'
import { ossMixin } from '@/components/form/runtime/components/mixins.js'

export default {
  name: 'peopleDetails',
  components: {
    SelectPeopleTree
  },
  props: ['depId', 'userId'],
  mixins: [ossMixin],
  data () {
    let isPhone = (rule, value, callback) => {
      if (
        value &&
        value.replace(/(^\s*)|(\s*$)/g, '') !== '' &&
        !/^1[3-9]\d{9}$/.test(value)
      ) {
        callback(new Error('请输入正确手机号'))
      }
      callback()
    }
    return {
      formData: {
        name: '',
        username: '',
        phone: '',
        email: '',
        state: '1',
        jobStatus: '1',
        departmentId: '',
        postId: '',
        jobNum: '',
        superior: '',
        superiorName: '',
        isAttendance: '是',
        attendanceTypeAddr: [],
        attendanceType: '固定考勤',
        remark: '',
        onDutyTimeStart: '9:00',
        onDutyTimeEnd: '',
        offDutyTimeStart: '17:00',
        offDutyTimeEnd: ''
      },
      formRules: {
        name: [
          { required: true, message: `请输入姓名`, trigger: 'blur' },
          { pattern: /^(?=.*\S).+$/, message: '请输入姓名', trigger: 'blur' }
        ],
        username: [
          { required: true, message: `请输入用户账号`, trigger: 'blur' },
          { pattern: /^(?=.*\S).+$/, message: '请输入用户账号', trigger: 'blur' }
        ],
        email: [
          { validator: this.isSomeEmail, trigger: 'blur' }
        ],
        phone: [{ validator: isPhone, trigger: 'blur' }]
      },
      imageUrl: '',
      // 下拉框数据
      selectList: {
        departmentList: [],
        postList: [],
        addressList: []
      },
      // 自定义组
      groups: [],
      // 基本信息组
      basicGroup: {},
      // 基本信息表的属性
      normalGroup: [
        {
          isShow: '',
          isFill: '',
          name: ''
        },
        {
          isShow: '',
          isFill: '',
          name: ''
        },
        {
          isShow: '',
          isFill: '',
          name: ''
        },
        {
          isShow: '',
          isFill: '',
          name: ''
        },
        {
          isShow: '',
          isFill: '',
          name: ''
        },
        {
          isShow: '',
          isFill: '',
          name: ''
        },
        {
          isShow: '',
          isFill: '',
          name: ''
        },
        {
          isShow: '',
          isFill: '',
          name: ''
        },
        {
          isShow: '',
          isFill: '',
          name: ''
        },
        {
          isShow: '',
          isFill: '',
          name: ''
        },
        {
          isShow: '',
          isFill: '',
          name: ''
        },
        {
          isShow: '',
          isFill: '',
          name: ''
        },
        {
          isShow: '',
          isFill: '',
          name: ''
        },
        {
          isShow: '',
          isFill: '',
          name: ''
        },
        {
          isShow: '',
          isFill: '',
          name: ''
        },
        {
          isShow: '',
          isFill: '',
          name: ''
        },
        {
          isShow: '',
          isFill: '',
          name: ''
        }
      ],
      errorMessage: {
        offDutyTime: '',
        onDutyTime: ''
      },
      isGetData: false,
      isClearPostId: false,
      uploadUrl: `${process.env.UPLOAD_URL}/api/upload-image`,
      memberDialog: {
        dialogVisible: false,
        filterText: '',
        selectedList: []
      },
      imageName: ''
    }
  },
  methods: {
    isSomeEmail (rule, value, callback) {
      if (!value) callback()
      let reg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/
      if (!reg.test(value)) {
        callback(new Error('请输入正确邮箱'))
      } else {
        let userId = this.userId || ''
        this.$axios.get(`/auth-api/users/emailCheck?email=${value}&userId=${userId}`).then(res => {
          if (res.data) {
            callback(new Error(`该邮箱已被“${res.data}”占用`))
          } else {
            callback()
          }
        })
      }
    },
    uploadFile (files) {
      let file = files.file
      let key = this.getOssKey('SYSTEM', file.name)
      let url = sessionStorage.getItem('ossDownloadUrl')
      let formData = this.getUploadFormData(key, file)
      this.$axios.post(url, formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(res => {
        res.status === 200 && this.handleAvatarSuccess(this.getResult(key, file.name))
      })
    },
    handleAvatarSuccess (res) {
      this.imageUrl = res[0].result.dir
    },
    getDownLoadUrl (path) {
      return sessionStorage.getItem('ossDownloadUrl') + path
    },
    beforeAvatarUpload (file) {
      let type = file.type
      let result = true
      if (type !== 'image/jpeg' && type !== 'image/png') {
        this.$message.error('上传头像图片只能是 jpg 或 png 格式!')
        result = false
      } else {
        if (file.size / 1024 / 1024 > 2) {
          this.$message.error('上传头像图片大小不能超过 2MB!')
          result = false
        }
      }
      return result
    },
    // 获取岗位列表
    getPostList (e) {
      return new Promise((resolve, reject) => {
        this.$axios.get(`/auth-api/posts/getPosts/${e}`).then(res => {
          this.selectList.postList = res.data
          this.$nextTick(() => {
            resolve()
          })
        })
      })
    },
    // 获取部门列表
    getDepartmentList () {
      return new Promise((resolve, reject) => {
        this.$axios.get(`/auth-api/departments`).then(res => {
          this.selectList.departmentList = res.data
          this.$nextTick(() => {
            resolve()
          })
        })
      })
    },
    // 获取考勤地址
    getAddress () {
      return new Promise((resolve, reject) => {
        this.$axios.get(`/auth-api/address/noPage`).then(res => {
          this.selectList.addressList = res.data
          this.$nextTick(() => {
            resolve()
          })
        })
      })
    },
    // 获取用户信息
    getUserInfo () {
      return new Promise((resolve, reject) => {
        this.formData.departmentId = this.depId
        if (this.userId) {
          this.$axios
            .get(`/auth-api/users/getNewUser/${this.userId}`)
            .then(res => {
              this.isGetData = true
              if (res.data.attendanceTypeAddr) {
                res.data.attendanceTypeAddr = res.data.attendanceTypeAddr.split(',')
              } else {
                res.data.attendanceTypeAddr = []
              }
              // this.formData = res.data 这样写会导致 没有返回的key无法做到数据绑定
              let data = Object.assign({...this.formData}, res.data)
              this.$set(this, 'formData', data)
              if (
                this.formData.attendanceType &&
                this.formData.attendanceType === '弹性考勤'
              ) {
                let onDutyTimes = this.formData.onDutyTime
                  ? this.formData.onDutyTime.split('|')
                  : []
                let offDutyTimes = this.formData.offDutyTime
                  ? this.formData.offDutyTime.split('|')
                  : []
                this.formData.onDutyTimeStart = onDutyTimes[0]
                this.formData.onDutyTimeEnd = onDutyTimes[1]
                this.formData.offDutyTimeStart = offDutyTimes[0]
                this.formData.offDutyTimeEnd = offDutyTimes[1]
              } else if (this.formData.attendanceType === '固定考勤') {
                this.formData.onDutyTimeStart = this.formData.onDutyTime
                this.formData.offDutyTimeStart = this.formData.offDutyTime
              }
              if (res.data.picture) {
                let iamgeList = res.data.picture.split('$.$')
                this.imageUrl = '/' + iamgeList[1].split(',/')[1]
                this.imageName = iamgeList[1].split(',/')[0]
              }
              this.$nextTick(() => {
                resolve()
              })
            })
        } else {
          resolve()
        }
      })
    },
    // 获取控件
    getControls () {
      return new Promise((resolve, reject) => {
        this.$axios.get('/auth-api/customcolumns').then(res => {
          this.groups = res.data
          this.groups.forEach((item, index) => {
            if (item.isBuiltIn === true) {
              this.basicGroup = item
              this.groups.splice(index, 1)
            }
          })
          this.basicGroup.columns.forEach(item => {
            switch (item.name) {
              case '姓名':
                this.normalGroup[0] = item
                break
              case '账号':
                this.normalGroup[1] = item
                break
              case '邮箱':
                this.normalGroup[2] = item
                break
              case '手机号':
                this.normalGroup[3] = item
                break
              case '部门名称':
                this.normalGroup[4] = item
                break
              case '岗位名称':
                this.normalGroup[5] = item
                break
              case '直属上级':
                this.normalGroup[6] = item
                break
              case '工号':
                this.normalGroup[7] = item
                break
              case '用户状态':
                this.normalGroup[8] = item
                break
              case '在职状态':
                this.normalGroup[9] = item
                break
              case '是否考勤':
                this.normalGroup[10] = item
                break
              case '考勤地址设置':
                this.normalGroup[11] = item
                break
              case '考勤方式':
                this.normalGroup[12] = item
                break
              case '上班时间':
                this.normalGroup[13] = item
                break
              case '下班时间':
                this.normalGroup[14] = item
                break
              case '备注':
                this.normalGroup[15] = item
                break
              case '头像':
                this.normalGroup[16] = item
                break
            }
          })
          this.$nextTick(() => {
            resolve()
          })
        })
      })
    },
    // 保存数据
    saveData () {
      this.$refs.peopleDetails.validate(v => {
        if (v) {
          if (this.errorMessage.offDutyTime === '' && this.errorMessage.onDutyTime === '') {
            if (this.formData.attendanceTypeAddr) {
              if (typeof this.formData.attendanceTypeAddr === 'object') {
                this.formData.attendanceTypeAddr = this.formData.attendanceTypeAddr.join(',')
              }
            }
            let params = { ...this.formData }
            for (let key in params) {
              if (params[key] === null || params[key] === undefined) {
                delete params[key]
              }
            }
            if (this.formData.attendanceType && this.formData.attendanceType === '弹性考勤') {
              params.onDutyTime = `${this.formData.onDutyTimeStart}|${this.formData.onDutyTimeEnd}`
              params.offDutyTime = `${this.formData.offDutyTimeStart}|${this.formData.offDutyTimeEnd}`
            } else if (this.formData.attendanceType === '固定考勤') {
              params.onDutyTime = this.formData.onDutyTimeStart
              params.offDutyTime = this.formData.offDutyTimeStart
            }
            if (this.userId) {
              params.id = this.userId
              if (this.imageUrl) {
                params.picture = `$.$${this.imageName},${this.imageUrl}`
              }
            }
            // 部门id和岗位id修改之后需要同步修改name
            if (params.postId) {
              let post = this.selectList.postList.find(id => params.postId)
              params.postName = post ? post.name : ''
            } else {
              params.postName = ''
            }
            if (params.departmentId) {
              let department = this.selectList.departmentList.find(id => params.departmentId)
              params.departmentName = department ? department.name : ''
            } else {
              params.departmentName = ''
            }

            this.$axios.post('/auth-api/users/newSaveOrUpdateUser', params).then(res => {
              this.$emit('closeDialog', 'save')
            }).catch(() => {
              // 报错了 得把这个多选框变回去
              if (this.formData.attendanceTypeAddr) {
                this.formData.attendanceTypeAddr = this.formData.attendanceTypeAddr.split(',')
              }
            })
          } else {
            return false
          }
        } else {
          this.$nextTick(() => {
            let isError = document.querySelectorAll('.is-error')
            if (isError && isError.length !== 0) {
              if (isError[0].querySelector('input')) {
                isError[0].querySelector('input').focus()
              } else if (isError[0].querySelector('textarea')) {
                isError[0].querySelector('textarea').focus()
              }
            }
          })
          return false
        }
      })
    },
    // 关闭
    closePage () {
      this.$emit('closeDialog')
    },
    formateTime (str) {
      let timer = -1
      if (str && str.indexOf(':')) {
        let start = parseInt(str.split(':')[0])
        let end = parseInt(str.split(':')[1])
        timer = start * 60 + end
      }
      return timer
    },
    // 校验时间
    verifyTime (obj) {
      if (!this.isClear) {
        obj.start = this.formateTime(obj.start)
        obj.end = this.formateTime(obj.end)
        obj.inverseEnd = this.formateTime(obj.inverseEnd)
        obj.inverseStart = this.formateTime(obj.inverseStart)
        this.$nextTick(() => {
          if (
            this.formData.attendanceType &&
            this.formData.attendanceType === '弹性考勤'
          ) {
            this.errorMessage[obj.msg] = ''
            this.errorMessage[obj.msg] = ''
            this.errorMessage[obj.inverMsg] = ''
            this.$nextTick(() => {
              if (obj.msg === 'offDutyTime' && obj.start < obj.inverseEnd) {
                this.errorMessage[obj.msg] = '下班时间需要大于上班时间'
              } else if (
                obj.msg !== 'offDutyTime' &&
                obj.end > obj.inverseStart
              ) {
                this.errorMessage[obj.msg] = '下班时间需要大于上班时间'
              }
              if (obj.end < obj.start) {
                this.errorMessage[obj.msg] = '结束时间需要大于开始时间'
              } else if (obj.start === -1 && obj.end !== -1) {
                this.errorMessage[obj.msg] = '请选择结束时间'
              } else if (obj.start !== -1 && obj.end === -1) {
                this.errorMessage[obj.msg] = '请选择开始时间'
              } else if (obj.inverseStart !== -1 && obj.start === -1) {
                this.errorMessage[obj.str] = `请选择${obj.str}时间`
              }
            })
          } else {
            // 固定考勤走这里
            if (obj.inverseStart === -1) {
              if (obj.start !== -1 && obj.inverseStart === -1) {
                this.errorMessage[obj.inverMsg] = `请选择${obj.inverStr}时间`
              } else {
                this.errorMessage[obj.inverMsg] = ''
              }
            } else {
              this.errorMessage[obj.inverMsg] = ''
              this.$nextTick(() => {
                if (obj.msg === 'onDutyTime') {
                  if (obj.start > obj.inverseStart) {
                    this.errorMessage[obj.msg] = '下班时间需要大于上班时间'
                  } else {
                    this.errorMessage[obj.msg] = ''
                  }
                } else {
                  if (obj.start < obj.inverseStart) {
                    this.errorMessage[obj.msg] = '下班时间需要大于上班时间'
                  } else {
                    this.errorMessage[obj.msg] = ''
                  }
                }
              })
            }
          }
        })
      }
    },
    saveSuper (memberSelectedList) {
      if (memberSelectedList.length === 0) {
        this.$message({
          message: '你没有选择任何数据, 请选择后操作.',
          center: true,
          duration: 1000,
          customClass: 'without-execute-dialog'
        })
      } else if (memberSelectedList.length > 3) {
        this.$message({
          type: 'info',
          message: '直属上级最多可选3人',
          customClass: 'without-execute-dialog'
        })
      } else {
        this.formData.superior = memberSelectedList.map(m => m.id).join(',')
        this.formData.superiorName = memberSelectedList.map(m => m.name).join(',')
        this.memberDialog.dialogVisible = false
      }
    },
    onDutyTimeStartChange () {
      this.verifyTime({
        msg: 'onDutyTime',
        start: this.formData.onDutyTimeStart,
        end: this.formData.onDutyTimeEnd,
        str: '上班',
        inverseStart: this.formData.offDutyTimeStart,
        inverseEnd: this.formData.offDutyTimeEnd,
        inverStr: '下班',
        inverMsg: 'offDutyTime'
      })
    },
    onDutyTimeEndChange () {
      this.verifyTime({
        msg: 'onDutyTime',
        start: this.formData.onDutyTimeStart,
        end: this.formData.onDutyTimeEnd,
        str: '上班',
        inverseStart: this.formData.offDutyTimeStart,
        inverseEnd: this.formData.offDutyTimeEnd,
        inverStr: '下班',
        inverMsg: 'offDutyTime'
      })
    },
    offDutyTimeStartChange () {
      this.verifyTime({
        msg: 'offDutyTime',
        start: this.formData.offDutyTimeStart,
        end: this.formData.offDutyTimeEnd,
        str: '下班',
        inverseStart: this.formData.onDutyTimeStart,
        inverseEnd: this.formData.onDutyTimeEnd,
        inverStr: '上班',
        inverMsg: 'onDutyTime'
      })
    },
    offDutyTimeEndChange () {
      this.verifyTime({
        msg: 'offDutyTime',
        start: this.formData.offDutyTimeStart,
        end: this.formData.offDutyTimeEnd,
        str: '下班',
        inverseStart: this.formData.onDutyTimeStart,
        inverseEnd: this.formData.onDutyTimeEnd,
        inverStr: '上班',
        inverMsg: 'onDutyTime'
      })
    }
  },
  created () {
    Promise.all([
      this.getControls(),
      this.getDepartmentList(),
      this.getAddress(),
      this.getPostList(this.depId)
    ]).then(res => {
      return this.getUserInfo()
    }).then(() => {
      this.isClearPostId = true
    })
  },
  watch: {
    'formData.attendanceType': function (val) {
      this.isClear = true
      this.$nextTick(() => {
        // 如果是渲染数据，就不清空
        if (!this.isGetData) {
          this.formData.offDutyTimeStart = ''
          this.formData.offDutyTimeEnd = ''
          this.formData.onDutyTimeStart = ''
          this.formData.onDutyTimeEnd = ''
          this.errorMessage.offDutyTime = ''
          this.errorMessage.onDutyTime = ''
        }
        this.$nextTick(() => {
          this.isClear = false
          this.isGetData = false
        })
      })
    },
    'formData.departmentId': function (newVal, oldVal) {
      if (this.isClearPostId) {
        this.formData.postId = ''
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/common.scss";
.people-details-container {
  padding: 10px;
  height: 100%;

  div,
  span,
  p,
  label {
    font-size: 12px;
  }

  .el-form-item__content {
    width: 178px;

    .el-date-editor {
      width: 178px;
    }
  }

  .timer {
    .el-form-item__content {
      width: auto;
    }
  }

  .number-control {
    // 去除数字框的上下箭头
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: textfield;
    }
    input[type="number"] {
      -moz-appearance: textfield;
    }
  }

  .people-details-body {
    background: #fff;
    box-shadow: 0px 3px 9px 0px rgba(179, 196, 208, 0.2);
    border-radius: 4px 0;
    height: 100%;

    .content {
      height: 100%;
      padding: 20px;

      .form {
        height: calc(100% - 80px);
        overflow: auto;

        .people-details-input {
          .el-form-item.is-success .el-input__inner {
            border-color: #dcdfe6;
          }

          .el-form-item.is-success .el-input__inner:hover {
            border-color: #c0c4cc;
          }

          .el-form-item.is-success .el-input__inner:focus,
          .el-form-item.is-success .el-textarea__inner,
          .el-form-item.is-success .el-textarea__inner:focus {
            border-color: #409eff;
            outline: 0;
          }
        }

        .el-form-item__label {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .item {
          .fieldset {
            border: 1px solid #ccc;
            border-radius: 5px;
            font-size: 14px;
            color: #232323;

            .fixation-info {
              display: flex;
              justify-content: space-between;
              padding: 0 20px 20px 0;

              .avatar-uploader {
                .el-upload {
                  border: 1px dashed #d9d9d9;
                  border-radius: 6px;
                  cursor: pointer;
                  position: relative;
                  overflow: hidden;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 200px;
                  height: 220px;

                  &:hover {
                    border-color: var(--primary, #409eff);
                  }
                }

                .el-upload__input {
                  display: none;
                }

                .avatar-uploader-icon {
                  font-size: 28px;
                  color: #8c939d;
                  width: 178px;
                  height: 200px;
                  line-height: 200px;
                  text-align: center;
                }

                .avatar {
                  width: 100%;
                  height: 100%;
                  display: block;
                }
              }

              .remark {
                width: 100%;

                .el-form-item {
                  width: 100%;

                  .el-form-item__content {
                    width: calc(100% - 175px);
                  }
                }
              }

              .left {
                flex: 5;
                .selected {
                  color: var(--primary, #54ABF1);
                  cursor: pointer;
                }
              }

              .right {
                flex: 1;
              }
            }

            .details-info {
              padding-left: 20px;
            }
          }

          .legend {
            margin-left: 20px;
            font-size: 14px;
            padding: 10px;
          }
        }

        .item:not(:last-child) {
          padding-bottom: 15px;
        }
      }

      .operation {
        text-align: center;
        padding-top: 20px;
      }
    }
  }
}
.people-detail-dialog {
  .el-dialog {
  height: 576px;
  border-radius: 4px;
  .pagination {
    float: right;
  }
  .el-dialog__header {
    padding: 0px;
    height: 34px;
    line-height: 34px;
    background: #EDEEEE;
    .el-dialog__title {
      font-size: 14px;
      color: #2C2C2C;
    }
    .el-dialog__headerbtn {
      top: 10px;
    }
  }
  .el-dialog__body{
    height: 490px;
  }
}
}
</style>



// WEBPACK FOOTER //
// src/components/system/users/people-details.vue